import { API } from '@utils';

export const addWaitingListItem = async (waitingListToAdd: IWaitingList) => {
  const response = await API.post<IWaitingList[]>('WaitingList/Add', [
    waitingListToAdd,
  ]);
  return response?.[0];
};
